// extracted by mini-css-extract-plugin
export default {"inputContainer":"BoardInputsWorbox_inputContainer__oUqmz"};